import React from 'react';

export default function BlueprintBg() {
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 0,
      overflow: 'hidden',
      pointerEvents: 'none',
    }}>
      <svg
        width="100%" height="100%"
        viewBox="0 0 680 520"
        preserveAspectRatio="xMidYMid slice"
        style={{ opacity: 0.055 }}
        aria-hidden="true"
      >
        <defs>
          <pattern id="bp-grid" width="20" height="20" patternUnits="userSpaceOnUse">
            <path d="M 20 0 L 0 0 0 20" fill="none" stroke="currentColor" strokeWidth="0.4"/>
          </pattern>
          <pattern id="bp-finegrid" width="4" height="4" patternUnits="userSpaceOnUse">
            <path d="M 4 0 L 0 0 0 4" fill="none" stroke="currentColor" strokeWidth="0.15"/>
          </pattern>
          <marker id="bp-arrow" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="5" markerHeight="5" orient="auto-start-reverse">
            <path d="M2 1L8 5L2 9" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </marker>
        </defs>

        {/* Grids */}
        <rect width="680" height="520" fill="url(#bp-finegrid)"/>
        <rect width="680" height="520" fill="url(#bp-grid)"/>

        {/* Outer border */}
        <rect x="10" y="10" width="660" height="500" fill="none" stroke="currentColor" strokeWidth="1.5"/>
        <rect x="16" y="16" width="648" height="488" fill="none" stroke="currentColor" strokeWidth="0.4"/>

        {/* Center crosshairs */}
        <line x1="340" y1="10" x2="340" y2="510" stroke="currentColor" strokeWidth="0.3" strokeDasharray="4 6"/>
        <line x1="10" y1="260" x2="670" y2="260" stroke="currentColor" strokeWidth="0.3" strokeDasharray="4 6"/>

        {/* ── Mainspring barrel ── */}
        <circle cx="170" cy="210" r="78" fill="none" stroke="currentColor" strokeWidth="1.2"/>
        <circle cx="170" cy="210" r="74" fill="none" stroke="currentColor" strokeWidth="0.3"/>
        <circle cx="170" cy="210" r="62" fill="none" stroke="currentColor" strokeWidth="0.5"/>
        <circle cx="170" cy="210" r="50" fill="none" stroke="currentColor" strokeWidth="0.5"/>
        <circle cx="170" cy="210" r="38" fill="none" stroke="currentColor" strokeWidth="0.5"/>
        <circle cx="170" cy="210" r="26" fill="none" stroke="currentColor" strokeWidth="0.5"/>
        <circle cx="170" cy="210" r="10" fill="none" stroke="currentColor" strokeWidth="1"/>
        <circle cx="170" cy="210" r="3.5" fill="currentColor"/>
        <line x1="170" y1="210" x2="170" y2="148" stroke="currentColor" strokeWidth="0.6"/>
        <line x1="170" y1="210" x2="224" y2="243" stroke="currentColor" strokeWidth="0.6"/>
        <line x1="170" y1="210" x2="116" y2="243" stroke="currentColor" strokeWidth="0.6"/>
        <circle cx="170" cy="132" r="5" fill="none" stroke="currentColor" strokeWidth="0.8"/>
        <circle cx="248" cy="210" r="5" fill="none" stroke="currentColor" strokeWidth="0.8"/>
        <circle cx="170" cy="288" r="5" fill="none" stroke="currentColor" strokeWidth="0.8"/>
        <circle cx="92" cy="210" r="5" fill="none" stroke="currentColor" strokeWidth="0.8"/>
        <line x1="90" y1="292" x2="250" y2="292" stroke="currentColor" strokeWidth="0.5" markerStart="url(#bp-arrow)" markerEnd="url(#bp-arrow)"/>
        <text x="170" y="144" textAnchor="middle" fontFamily="'Space Mono',monospace" fontSize="8">MAINSPRING BARREL</text>
        <text x="170" y="306" textAnchor="middle" fontFamily="'Space Mono',monospace" fontSize="7">Ø 15.8mm</text>

        {/* ── Center wheel ── */}
        <circle cx="355" cy="195" r="48" fill="none" stroke="currentColor" strokeWidth="1"/>
        <circle cx="355" cy="195" r="50" fill="none" stroke="currentColor" strokeWidth="2.5" strokeDasharray="3.8 2.4"/>
        <circle cx="355" cy="195" r="8" fill="none" stroke="currentColor" strokeWidth="0.9"/>
        <circle cx="355" cy="195" r="3" fill="currentColor"/>
        <line x1="355" y1="195" x2="355" y2="147" stroke="currentColor" strokeWidth="0.6"/>
        <line x1="355" y1="195" x2="396" y2="220" stroke="currentColor" strokeWidth="0.6"/>
        <line x1="355" y1="195" x2="396" y2="170" stroke="currentColor" strokeWidth="0.6"/>
        <line x1="355" y1="195" x2="314" y2="170" stroke="currentColor" strokeWidth="0.6"/>
        <line x1="355" y1="195" x2="314" y2="220" stroke="currentColor" strokeWidth="0.6"/>
        <text x="355" y="162" textAnchor="middle" fontFamily="'Space Mono',monospace" fontSize="7.5">CTR WHEEL</text>

        {/* ── Third wheel ── */}
        <circle cx="448" cy="158" r="32" fill="none" stroke="currentColor" strokeWidth="0.9"/>
        <circle cx="448" cy="158" r="34" fill="none" stroke="currentColor" strokeWidth="1.8" strokeDasharray="2.8 2"/>
        <circle cx="448" cy="158" r="6" fill="none" stroke="currentColor" strokeWidth="0.8"/>
        <circle cx="448" cy="158" r="2.5" fill="currentColor"/>
        <line x1="448" y1="158" x2="448" y2="126" stroke="currentColor" strokeWidth="0.5"/>
        <line x1="448" y1="158" x2="476" y2="174" stroke="currentColor" strokeWidth="0.5"/>
        <line x1="448" y1="158" x2="420" y2="174" stroke="currentColor" strokeWidth="0.5"/>
        <text x="448" y="122" textAnchor="middle" fontFamily="'Space Mono',monospace" fontSize="7">3RD WHEEL</text>

        {/* ── Fourth wheel ── */}
        <circle cx="498" cy="235" r="24" fill="none" stroke="currentColor" strokeWidth="0.8"/>
        <circle cx="498" cy="235" r="26" fill="none" stroke="currentColor" strokeWidth="1.8" strokeDasharray="2.2 1.8"/>
        <circle cx="498" cy="235" r="5" fill="none" stroke="currentColor" strokeWidth="0.7"/>
        <circle cx="498" cy="235" r="2" fill="currentColor"/>
        <text x="498" y="276" textAnchor="middle" fontFamily="'Space Mono',monospace" fontSize="7">4TH WHL</text>

        {/* Gear mesh dashes */}
        <line x1="248" y1="205" x2="305" y2="200" stroke="currentColor" strokeWidth="0.4" strokeDasharray="3 3"/>
        <line x1="403" y1="180" x2="416" y2="174" stroke="currentColor" strokeWidth="0.4" strokeDasharray="3 3"/>
        <line x1="460" y1="188" x2="474" y2="212" stroke="currentColor" strokeWidth="0.4" strokeDasharray="3 3"/>

        {/* ── Escape wheel ── */}
        <circle cx="558" cy="185" r="38" fill="none" stroke="currentColor" strokeWidth="0.9"/>
        <circle cx="558" cy="185" r="40" fill="none" stroke="currentColor" strokeWidth="1.8" strokeDasharray="2 3.6"/>
        <circle cx="558" cy="185" r="7" fill="none" stroke="currentColor" strokeWidth="0.9"/>
        <circle cx="558" cy="185" r="3" fill="currentColor"/>
        <line x1="558" y1="185" x2="558" y2="147" stroke="currentColor" strokeWidth="0.6"/>
        <line x1="558" y1="185" x2="591" y2="204" stroke="currentColor" strokeWidth="0.6"/>
        <line x1="558" y1="185" x2="591" y2="166" stroke="currentColor" strokeWidth="0.6"/>
        <line x1="558" y1="185" x2="525" y2="204" stroke="currentColor" strokeWidth="0.6"/>
        <line x1="558" y1="185" x2="525" y2="166" stroke="currentColor" strokeWidth="0.6"/>
        <circle cx="558" cy="147" r="4" fill="none" stroke="currentColor" strokeWidth="0.7"/>
        <circle cx="558" cy="223" r="4" fill="none" stroke="currentColor" strokeWidth="0.7"/>
        <text x="596" y="180" textAnchor="start" fontFamily="'Space Mono',monospace" fontSize="7.5">ESC WHL</text>

        {/* ── Pallet fork ── */}
        <path d="M558 227 L538 268 L528 278 L538 288 L558 264 L578 288 L588 278 L578 268 Z" fill="none" stroke="currentColor" strokeWidth="0.9"/>
        <circle cx="558" cy="264" r="6" fill="none" stroke="currentColor" strokeWidth="0.8"/>
        <circle cx="558" cy="264" r="2" fill="currentColor"/>
        <rect x="524" y="275" width="10" height="6" rx="1" fill="none" stroke="currentColor" strokeWidth="0.7"/>
        <rect x="572" y="275" width="10" height="6" rx="1" fill="none" stroke="currentColor" strokeWidth="0.7"/>
        <text x="610" y="268" textAnchor="start" fontFamily="'Space Mono',monospace" fontSize="7">PALLET</text>
        <text x="610" y="277" textAnchor="start" fontFamily="'Space Mono',monospace" fontSize="7">FORK</text>

        {/* ── Balance wheel ── */}
        <circle cx="310" cy="375" r="54" fill="none" stroke="currentColor" strokeWidth="1.1"/>
        <circle cx="310" cy="375" r="50" fill="none" stroke="currentColor" strokeWidth="0.3"/>
        <circle cx="310" cy="375" r="10" fill="none" stroke="currentColor" strokeWidth="1"/>
        <circle cx="310" cy="375" r="4" fill="currentColor"/>
        <line x1="310" y1="375" x2="310" y2="321" stroke="currentColor" strokeWidth="0.8"/>
        <line x1="310" y1="375" x2="310" y2="429" stroke="currentColor" strokeWidth="0.8"/>
        <line x1="310" y1="375" x2="256" y2="375" stroke="currentColor" strokeWidth="0.8"/>
        <line x1="310" y1="375" x2="364" y2="375" stroke="currentColor" strokeWidth="0.8"/>
        {/* Rim screws */}
        {[0,22.5,45,67.5,90,112.5,135,157.5,180,202.5,225,247.5,270,292.5,315,337.5].map((deg, i) => {
          const r = 52;
          const rad = (deg * Math.PI) / 180;
          const x = 310 + r * Math.cos(rad);
          const y = 375 + r * Math.sin(rad);
          return <circle key={i} cx={x} cy={y} r="2.8" fill="none" stroke="currentColor" strokeWidth="0.6"/>;
        })}
        {/* Hairspring */}
        <path d="M310,375 Q326,373 328,360 Q330,344 317,336 Q302,328 290,336 Q276,346 278,362 Q280,380 296,387 Q314,393 328,384 Q344,374 343,356 Q341,334 324,324" fill="none" stroke="currentColor" strokeWidth="0.6"/>
        <circle cx="310" cy="321" r="5" fill="none" stroke="currentColor" strokeWidth="0.9"/>
        <circle cx="310" cy="429" r="5" fill="none" stroke="currentColor" strokeWidth="0.9"/>
        <text x="310" y="447" textAnchor="middle" fontFamily="'Space Mono',monospace" fontSize="8">BALANCE WHEEL — Ø 10.5mm</text>

        {/* ── Plate/bridge outlines ── */}
        <rect x="55" y="82" width="570" height="378" rx="14" fill="none" stroke="currentColor" strokeWidth="0.5" strokeDasharray="8 6"/>
        <path d="M94 122 Q170 104 252 122 L252 302 Q170 320 94 302 Z" fill="none" stroke="currentColor" strokeWidth="0.4" strokeDasharray="5 5"/>
        <path d="M276 112 Q396 96 518 112 L536 218 Q396 234 276 218 Z" fill="none" stroke="currentColor" strokeWidth="0.4" strokeDasharray="5 5"/>
        <path d="M245 322 Q278 307 336 316 Q376 323 387 355 Q391 385 368 403 Q348 418 320 413 Q292 408 274 390 Q256 370 245 346 Z" fill="none" stroke="currentColor" strokeWidth="0.5" strokeDasharray="5 5"/>

        {/* ── Dimension lines ── */}
        <line x1="34" y1="82" x2="34" y2="460" stroke="currentColor" strokeWidth="0.5" markerStart="url(#bp-arrow)" markerEnd="url(#bp-arrow)"/>
        <line x1="34" y1="82" x2="55" y2="82" stroke="currentColor" strokeWidth="0.3"/>
        <line x1="34" y1="460" x2="55" y2="460" stroke="currentColor" strokeWidth="0.3"/>
        <line x1="55" y1="480" x2="625" y2="480" stroke="currentColor" strokeWidth="0.5" markerStart="url(#bp-arrow)" markerEnd="url(#bp-arrow)"/>
        <line x1="55" y1="460" x2="55" y2="482" stroke="currentColor" strokeWidth="0.3"/>
        <line x1="625" y1="460" x2="625" y2="482" stroke="currentColor" strokeWidth="0.3"/>

        {/* ── Title block ── */}
        <rect x="462" y="458" width="195" height="42" fill="none" stroke="currentColor" strokeWidth="0.6"/>
        <line x1="462" y1="469" x2="657" y2="469" stroke="currentColor" strokeWidth="0.4"/>
        <text x="472" y="467" fontFamily="'Space Mono',monospace" fontSize="6.5">CALIBER: DM-001</text>
        <text x="472" y="479" fontFamily="'Space Mono',monospace" fontSize="6">MOVEMENT LAYOUT — PLAN VIEW</text>
        <text x="472" y="491" fontFamily="'Space Mono',monospace" fontSize="6">SCALE 1:1 — 28 JEWELS — 28800 BPH</text>

        {/* Corner registration marks */}
        <line x1="38" y1="28" x2="52" y2="28" stroke="currentColor" strokeWidth="0.6"/>
        <line x1="45" y1="22" x2="45" y2="36" stroke="currentColor" strokeWidth="0.6"/>
        <circle cx="45" cy="28" r="4" fill="none" stroke="currentColor" strokeWidth="0.4"/>
        <line x1="628" y1="28" x2="642" y2="28" stroke="currentColor" strokeWidth="0.6"/>
        <line x1="635" y1="22" x2="635" y2="36" stroke="currentColor" strokeWidth="0.6"/>
        <circle cx="635" cy="28" r="4" fill="none" stroke="currentColor" strokeWidth="0.4"/>
      </svg>
    </div>
  );
}
